export const LIST_ITEM_TEXT_LENGTH = 300;
